import { useCommonUserRetrieve } from "@boundless/bl-api-client/common/services"

import { OnboardingFooter } from "@/components/onboarding/OnboardingFooter"
import { OnboardingHero } from "@/components/onboarding/OnboardingHero"
import { OnboardingPanel } from "@/components/onboarding/OnboardingPanel"

interface Props {
  onNext: () => void
}

/** The opener. Asks nothing, so it saves nothing. */
export function WelcomeStep({ onNext }: Props) {
  // A partner's borrower must not meet the Boundless name on the very first
  // screen, so the neutral title is also what shows while the user is still
  // loading.
  const { data: user } = useCommonUserRetrieve()
  const title = user && !user.partnerSlug ? "Welcome to Boundless" : "Welcome"

  return (
    <>
      <OnboardingHero badge="Onboarding" size="welcome" />
      <OnboardingPanel
        title={title}
        description="Let’s get you started — a few quick questions about your business, then we handle the rest."
      />
      <OnboardingFooter label="Let’s go" onNext={onNext} />
    </>
  )
}
